// Feature flag names checked through FeatureFlagService and the *appFeatureFlag directive. Flags the
// server also gates are mirrored in Aclarian.Workflow.Core.Services/Configurations/FeatureFlags.cs;
// keep the two in step.
export const FEATURE_FLAGS = {
	AGENCY_VEHICLE_AVAILABLE: 'AgencyVehicleAvailable',
	AI_AGENTS: 'AIAgents',
	AI_GL_SUGGESTION: 'AIGlSuggestion',
	AI_PROCUREMENT_REVIEW: 'AIProcurementReview',
	CONTRACT_DOCUMENT_INTELLIGENCE: 'ContractDocumentIntelligence',
	FORM_TIMELINE: 'FormTimeline',
	IS_INVENTORY_LOCATION_ALLOWED: 'IsInventoryLocationAllowed',
	LEGACY_VENDOR_ID: 'LegacyVendorId',
	POLICIES_PROCEDURES_AI_BUILDER: 'PoliciesProceduresAiBuilder',
	PORTAL_AGENT: 'PortalAgent',
	PRE_PRINTED_CHECK_BANK_ACCOUNT_SELECTION_ALLOWED: 'PrePrintedCheckBankAccountSelectionAllowed',
	WORKFLOW_EDITABLE_FIELD_RESTRICTION_ALLOWED: 'WorkflowEditableFieldRestrictionAllowed',
} as const;

export type FeatureFlagName = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
